Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
  cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  this.money_format = window.money_format;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }

  // Minor units by currency (fallback 2)
  var MINOR_UNITS = {
      JPY: 0, KRW: 0, VND: 0, CLP: 0, XOF: 0, XAF: 0, XPF: 0, HUF: 0, RWF: 0, UGX: 0,
      BIF: 0, DJF: 0, GNF: 0, KMF: 0, PYG: 0, VUV: 0,
      BHD: 3, IQD: 3, JOD: 3, KWD: 3, LYD: 3, OMR: 3, TND: 3, MGA: 1
  };

  function getCurrency() {
      if (window.shopSettings && window.shopSettings.currency) return window.shopSettings.currency;
      if (window.Shopify && Shopify.currency && (Shopify.currency.active || Shopify.currency)) {
          return Shopify.currency.active || Shopify.currency;
      }
      return 'USD';
  }

  function getFractionDigits(code) {
      code = (code || '').toString().toUpperCase();
      return Object.prototype.hasOwnProperty.call(MINOR_UNITS, code) ? MINOR_UNITS[code] : 2;
  }

  function toMajor(minor, currency) {
      var digits = getFractionDigits(currency);
      if (digits === 0) return Number(minor);
      return Number(minor) / Math.pow(10, digits);
  }

  function formatWithIntl(minor, precision, separators) {
      var currency = getCurrency();
      var digits = getFractionDigits(currency);
      // keep at most the currency's fraction digits
      var finalPrecision = Math.min(defaultOption(precision, digits), digits);
      var major = toMajor(minor, currency);

      // Use en-US for deterministic "," thousands and "." decimal, then swap if needed
      var nf = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: finalPrecision,
          maximumFractionDigits: finalPrecision,
          useGrouping: true
      });
      var out = nf.format(major);
      if (separators && (separators.thousands || separators.decimal)) {
          var thousands = defaultOption(separators.thousands, ',');
          var decimal = defaultOption(separators.decimal, '.');
          if (thousands !== ',' || decimal !== '.') {
              out = out.replace(/,/g, '__TMP__').replace(/\./g, decimal).replace(/__TMP__/g, thousands);
          }
      }
      return out;
  }

  var match = formatString.match(placeholderRegex);
  var token = match ? match[1] : 'amount';
  switch (token) {
      case 'amount':
          value = formatWithIntl(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithIntl(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithIntl(cents, 2, { thousands: '.', decimal: ',' });
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithIntl(cents, 0, { thousands: '.', decimal: ',' });
          break;
      default:
          value = formatWithIntl(cents, getFractionDigits(getCurrency()));
          break;
  }
  return formatString.replace(placeholderRegex, value);
  };

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

window.scriptLoadMap = {};

/**
 * Mark/store the script as fully loaded in a global variable.
 * @param src URL of the script
 */
function markScriptFullyLoaded(src) {
  window.scriptLoadMap[src] = true;
}

/**
 * Returns true if the script has been added to the page
 * @param src URL of the script
 */
function isScriptAdded(src) {
  return Boolean(document.querySelector('script[src="' + src + '"]'));
}

/**
 * Returns true if the script has been fully loaded
 * @param src URL of the script
 */
function isScriptFullyLoaded(src) {
  return src in window.scriptLoadMap && window.scriptLoadMap[src];
}

/**
 * Load a script.
 * @param src URL of the script
 * @param onLoadCallback Callback function when the script is fully loaded
 * @param onLoadErrorCallback Callback function when the script fails to load
 */
function loadScript(src, onLoadCallback, onLoadErrorCallback) {
  if (!src) return;

  // Check if the script is already loaded
  if (isScriptAdded(src)) {
    // If script already loaded successfully, trigger the callback function
    if (isScriptFullyLoaded(src) && onLoadCallback) onLoadCallback();

    console.warn("Script already loaded. Skipping: ", src);
    return;
  }

  // Loading the script...
  const script = document.createElement("script");
  script.src = src;
  script.onload = () => {
    markScriptFullyLoaded(src);

    // Optional callback on script load
    if (onLoadCallback) onLoadCallback();
  };

  script.onerror = () => {
    // Remove the script node (to be able to try again later)
    const js2 = document.querySelector('script[src="' + src + '"]');
    js2.parentNode.removeChild(js2);

    // Optional callback on script load failure
    if (onLoadErrorCallback) onLoadErrorCallback();
  };

  document.head.appendChild(script);
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Object.assign(window.Shopify, {
  addSizeToImage: function addSizeToImage(src, width, height) {
    const url = new URL(
      src,
      window.location.protocol + "//" + window.Shopify.cdnHost
    );

    width && url.searchParams.append("width", width);
    height && url.searchParams.append("height", height);

    return url.toString();
  },
  getHandle: function getHandle(str) {
    const [match] = str.match(/(?!(.*\/))(.*?)(?=\#|\?|\.|$)/gm);
    return match;
  },
  handleize: function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, "-")
      .replace(/^-+|-+$/g, "");
  },
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.currentTarget.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function serializeForm(form) {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

// ---------------------------------------------------------------------------
// Resilient cart fetch helpers
// ---------------------------------------------------------------------------
// Shopify rate-limits the AJAX Cart API. When a session fires too many /cart/*
// requests in a short window (easy to hit when a shopper adds several items
// quickly), Shopify replies with an HTML challenge / error page (HTTP 429/430)
// instead of JSON. Calling response.json() on that HTML body throws
//   Unexpected token <, "<!DOCTYPE "... is not valid JSON
// which some add-to-cart paths surfaced verbatim to shoppers as a red toast.
//
// parseCartResponse() guarantees the caller either gets valid parsed JSON or a
// clean, user-friendly Error — it never feeds an HTML body to JSON.parse.
window.CART_THROTTLE_MESSAGE =
  window.CART_THROTTLE_MESSAGE ||
  "We couldn't add that just now — please refresh the page and try again.";

async function parseCartResponse(response) {
  // Throttle / bot-challenge: body is an HTML page, not JSON.
  if (response.status === 429 || response.status === 430) {
    const err = new Error(window.CART_THROTTLE_MESSAGE);
    err.code = "THROTTLED";
    err.status = response.status;
    err.retryAfter = parseInt(response.headers.get("Retry-After") || "0", 10);
    throw err;
  }

  const text = await response.text();
  const trimmed = (text || "").trim();
  const contentType = response.headers.get("content-type") || "";
  const looksJson =
    contentType.includes("json") ||
    trimmed.startsWith("{") ||
    trimmed.startsWith("[");

  if (!looksJson) {
    // e.g. <!DOCTYPE html> challenge / password / error page
    const err = new Error(window.CART_THROTTLE_MESSAGE);
    err.code = "NON_JSON";
    err.status = response.status;
    throw err;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    const err = new Error("Something went wrong. Please try again.");
    err.code = "PARSE";
    throw err;
  }
}

// fetch() + parseCartResponse() with a single retry on transient throttling.
// Returns { response, json } so callers keep their existing
// `if (!response.ok || json.status)` validation. A throttled request is
// rejected by Shopify before the cart is modified, so retrying it is safe and
// never double-adds.
async function fetchCartJSON(url, config, options) {
  const { retries = 1, backoffMs = 800 } = options || {};
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const response = await fetch(url, config);
      const json = await parseCartResponse(response);
      return { response, json };
    } catch (err) {
      lastErr = err;
      const transient = err && (err.code === "THROTTLED" || err.code === "NON_JSON");
      if (transient && attempt < retries) {
        const wait = err.retryAfter ? err.retryAfter * 1000 : backoffMs * (attempt + 1);
        await new Promise((resolve) => setTimeout(resolve, wait));
        continue;
      }
      throw err;
    }
  }
  throw lastErr;
}

// Debounced post-add side-effects. Every add-to-cart triggers secondary chores
// — runAutoGift, runAutoDonation and a full-cart refresh — that each hit /cart/*.
// Running them on EVERY add multiplies request volume (~4-6 /cart/* calls per
// add) and is the main reason rapid multi-add trips Shopify's rate limit.
// Debouncing collapses N rapid adds into ONE round of chores once the burst
// settles. Immediate UI (cart icon bubble / notification) is rendered straight
// from each add response, so this short delay is invisible to the shopper.
let _postAddChoresTimer = null;
function runPostAddChores(delay = 500) {
  if (_postAddChoresTimer) clearTimeout(_postAddChoresTimer);
  _postAddChoresTimer = setTimeout(async () => {
    _postAddChoresTimer = null;
    // The cart just changed, so drop any cached snapshot — the first read below
    // fetches fresh, and the gift/donation reads then share it (see getCart).
    invalidateCartCache();
    // Snapshot the mutation counter AFTER the invalidate above. Any cart write
    // between here and the publish below — a chore's own write, or a concurrent
    // one such as a quantity change in the open drawer — bumps it, which forces
    // the authoritative re-read instead of replaying the pre-chore snapshot.
    const epochAtRead = window.__mnCartEpoch;
    // Auto-add gift / donation BEFORE the final refresh so the synced cart count
    // reflects anything they added.
    try {
      if (typeof window.runAutoGift === "function") await window.runAutoGift();
    } catch (e) {
      console.error("runAutoGift failed", e);
    }
    try {
      if (typeof window.runAutoDonation === "function") await window.runAutoDonation();
    } catch (e) {
      console.error("runAutoDonation failed", e);
    }
    try {
      // When nothing wrote to the cart, the chores' shared getCart() read
      // (fetched fresh after the invalidate above) is still the current state —
      // reuse it instead of issuing a second /cart.js GET.
      const cachedRead =
        window.__mnCartEpoch === epochAtRead && window._cartCache && window._cartCache.promise
          ? await window._cartCache.promise.catch(() => null)
          : null;
      if (cachedRead) {
        if (typeof window.handleCartUpdated === "function") window.handleCartUpdated(cachedRead);
        else window.cartJSON = cachedRead;
      } else if (typeof window.refreshCartFromServer === "function") {
        await window.refreshCartFromServer();
      } else {
        const cart = await fetch("/cart.js", { method: "GET" }).then((r) => r.json());
        if (typeof window.handleCartUpdated === "function") window.handleCartUpdated(cart);
        else window.cartJSON = cart;
      }
    } catch (e) {
      console.error("refreshCartFromServer failed", e);
    }
  }, delay);
}
window.runPostAddChores = runPostAddChores;

// Single-flight queue for add-to-cart requests. A burst of rapid adds across
// different product cards otherwise fires many near-identical /cart/add.js POSTs
// CONCURRENTLY, which is the pattern Shopify's bot-detection throttles hardest.
// serializeCartAdd() chains them so each add's network call waits for the
// previous to settle — turning the burst into a sequential queue. The queue
// survives individual failures, and a per-task timeout stops one hung request
// from blocking every later add.
window._cartAddQueue = window._cartAddQueue || Promise.resolve();
function serializeCartAdd(task, timeoutMs = 12000) {
  const guarded = () =>
    Promise.race([
      Promise.resolve().then(task),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error(window.CART_THROTTLE_MESSAGE)), timeoutMs)
      ),
    ]);
  const run = window._cartAddQueue.then(guarded, guarded);
  // Keep the queue alive regardless of how this task settled.
  window._cartAddQueue = run.then(
    () => undefined,
    () => undefined
  );
  return run;
}
window.serializeCartAdd = serializeCartAdd;

// Short-lived, single-flight /cart.js cache. The debounced chore round makes
// several read-only cart lookups (auto-gift + auto-donation thresholds) back to
// back; getCart() lets them share ONE network request instead of each issuing
// their own. The TTL is short so deliberate, spaced-out actions always read
// fresh state, and invalidateCartCache() is called whenever the cart mutates.
// NOTE: refreshCartFromServer intentionally does NOT use this — it is the
// authoritative post-mutation sync and must always fetch fresh.
window._cartCache = window._cartCache || { at: 0, promise: null };
function getCart(maxAgeMs = 1000) {
  const cache = window._cartCache;
  const now = Date.now();
  if (cache.promise && now - cache.at < maxAgeMs) {
    return cache.promise;
  }
  cache.at = now;
  cache.promise = fetch("/cart.js", { method: "GET" })
    .then((r) => parseCartResponse(r))
    .catch((e) => {
      // Don't poison the cache on failure — clear so the next call refetches.
      window._cartCache = { at: 0, promise: null };
      throw e;
    });
  return cache.promise;
}
// Bumped on every cart mutation. runPostAddChores() compares it across the
// chore round to tell "nothing changed, the cached read is still current" from
// "something wrote to the cart while we were working, re-read before
// publishing". Any code path that writes to the cart MUST call this, otherwise
// a stale snapshot can be published over newer state.
window.__mnCartEpoch = window.__mnCartEpoch || 0;
function invalidateCartCache() {
  window._cartCache = { at: 0, promise: null };
  window.__mnCartEpoch += 1;
}
window.getCart = getCart;
window.invalidateCartCache = invalidateCartCache;

// Enforce the invariant above automatically: cart-drawer.js alone has 13 cart
// write sites (plus wishlist, Skio, PDP hero, and the React bundles) and none
// of them called invalidateCartCache — the exact stale-snapshot race the epoch
// was added to close stayed open on the highest-traffic path. Wrapping fetch
// once at the seam covers every current and future writer.
//
// The same seam counts cart writes still waiting on a response, apps' included:
// Swish's checkout bridge rewrites its _swish attribute with /cart/update.js
// through window.fetch (when a guest's first wishlist save mints a token, say),
// and Redo writes its redo_* attributes by XMLHttpRequest, so XHR is wrapped
// too. Shopify doesn't serialise cart writes, so one in flight alongside
// another saves the cart it started from and can put back a line the other
// just removed. cartWritesSettled() resolves once none is in flight (or after
// timeoutMs), so a write that must not be undone can wait, then read the cart
// back.
const __mnCartWriteUrl = /\/cart\/(add|change|update|clear)(\.js)?([/?#]|$)/;
let __mnCartWritesInFlight = 0;
let __mnCartWritesIdle = [];
function cartWritesSettled(timeoutMs = 5000) {
  if (!__mnCartWritesInFlight) return Promise.resolve();
  return new Promise((resolve) => {
    __mnCartWritesIdle.push(resolve);
    setTimeout(resolve, timeoutMs);
  });
}
window.cartWritesSettled = cartWritesSettled;

// Counts a cart write in; call what it returns once the write has answered.
function trackCartWrite() {
  __mnCartWritesInFlight += 1;
  let done = false;
  return () => {
    if (done) return;
    done = true;
    invalidateCartCache();
    __mnCartWritesInFlight -= 1;
    if (__mnCartWritesInFlight) return;
    const idle = __mnCartWritesIdle;
    __mnCartWritesIdle = [];
    idle.forEach((resolve) => resolve());
  };
}

if (!window.__mnCartEpochFetchWrapped) {
  window.__mnCartEpochFetchWrapped = true;
  const __mnOrigFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = __mnOrigFetch(input, init);
    if (__mnCartWriteUrl.test(url)) {
      const done = trackCartWrite();
      p.then(done, done);
    }
    return p;
  };
}

if (!window.__mnCartEpochXhrWrapped && window.XMLHttpRequest) {
  window.__mnCartEpochXhrWrapped = true;
  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__mnCartWrite = __mnCartWriteUrl.test(String(url));
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (!this.__mnCartWrite) return xhrSend.apply(this, arguments);
    const done = trackCartWrite();
    this.addEventListener('loadend', done, { once: true });
    try {
      return xhrSend.apply(this, arguments);
    } catch (e) {
      done();
      throw e;
    }
  };
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.menu-drawer__tab):not(.mn-drawer-close)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    // The MN drawer is shown by details[open] alone, so the 400ms close
    // animation would just freeze it on screen. Close it in the tap instead.
    // Sending it through closeSubmenu left a pending closeAnimation that shut
    // the drawer again if it was reopened within 400ms.
    this.querySelectorAll('.mn-drawer-close').forEach((button) =>
      button.addEventListener('click', (event) =>
        this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'), true)
      )
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      // Read before opening: reading innerHeight after the class changes
      // below forced a synchronous restyle inside the tap.
      const viewportHeight = window.innerHeight;
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      // Set on the drawer, not <html>: every element inherits a custom
      // property, so a write on the root restyled the whole page on each tap.
      // The only reader is the menu icon's backdrop inside this element.
      if (window.matchMedia('(max-width: 990px)')) {
        this.style.setProperty('--viewport-height', `${viewportHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    if (this.dataset.breakpoint) document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false, immediate = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    if (this.dataset.breakpoint) document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    // Remove `open` before focusing: the summary is hidden while the drawer is open.
    if (immediate) this.mainDetailsToggle.removeAttribute('open');
    removeTrapFocus(elementToFocus);
    if (!immediate) this.closeAnimation(this.mainDetailsToggle);

    if (immediate || event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class AutomaticTabs extends HTMLElement {
  constructor() {
    super();

    this.tabBG = this.querySelector(".tab-bg");
    this.tabList = this.querySelector(".tablist");
    this.tabs = Array.from(this.tabList.children).filter(ele => ele.tagName!= "SPAN");

    let tabPanelLengthCheck = this.querySelectorAll(".tabpanel").length
      if (tabPanelLengthCheck > 4) {
        this.tabPanels = Array.from(this.querySelectorAll(":scope > .tabpanel"));
      } else {
        this.tabPanels = Array.from(this.querySelectorAll(".tabpanel"));
      }
    this.tab = this.tabList.firstElementChild;

    this.addAccessibilityAttributes();
    this.bindEvents();
    this.handleSelect(this.tab)
  }

  bindEvents() {
    this.tabList.addEventListener("keydown", this.onKeyDown.bind(this));
    [...this.tabList.children].forEach((tab) => {
      tab.addEventListener("click", this.onClick.bind(this));
    });
  }

  addAccessibilityAttributes() {
    let using_target = false;
    this.tabList.setAttribute("role", "tablist");
    this.tabs.forEach((tab, i) => {
      tab.setAttribute("role", "tab");
      tab.setAttribute("aria-selected", i ? false : true);
      tab.setAttribute("tabindex", i ? -1 : 0);
      if(tab?.hasAttribute("data-target"))
        using_target = true
      if(!using_target)
        tab.setAttribute("aria-controls", this.tabPanels[i].id);
    });
    if(!using_target){
      this.tabPanels.forEach((tabPanel, i) => {
        tabPanel.setAttribute("role", "tabpanel");
        tabPanel.setAttribute("aria-labelledby", this.tabs[i].id);
        tabPanel.setAttribute("tabindex", 0);
        i && tabPanel.setAttribute("hidden", "hidden");
      });
    }
  }

  handleSelect(tab) {
    if(!tab) {
      console.error('tab is not found');
      return;
    }

    if(tab?.hasAttribute("data-target")){
      this.tabs.forEach((tb, i) => {
        // if(tb.getAttribute("data-target") != this.tab.getAttribute("data-target"))
        document.querySelectorAll(tb.getAttribute("data-target")).forEach(element => {
          element.setAttribute("hidden","hidden");
        })
      })
    }
    this.tab.setAttribute("tabindex", -1);
    this.tab.setAttribute("aria-selected", false);
    if(!tab?.hasAttribute("data-target")){
      document
        .getElementById(this.tab.getAttribute("aria-controls"))
        .setAttribute("hidden", "hidden");
    }
    // tab.focus();
    tab.setAttribute("aria-selected", true);
    tab.setAttribute("tabindex", 0);
    if(tab?.hasAttribute("data-target")){
      if(tab.getAttribute("data-target").length)
        document.querySelectorAll(tab.getAttribute("data-target")).forEach(element => {
          element.removeAttribute("hidden");
        });
    }else{
      document
        .getElementById(tab.getAttribute("aria-controls"))
        .removeAttribute("hidden");
    }
    this.tab = tab;

    /* Update background */
    if(this.tabBG){
      let left = 0;
      let width = 0;
      let found = false;
      this.tabList.querySelectorAll('button').forEach((tb,index) => {
        if( tb.id == this.tab.id ) {
          width = tab.offsetWidth;
          found = true;
        }
        if( tb.id != this.tab.id && !found ){
          left = parseInt(left) + parseInt(tb.offsetWidth);
        }
      });
      this.tabBG.style.minWidth = width + 'px';
      this.tabBG.style.left = left + 'px';
    }
  }

  onClick(event) {
    this.handleSelect(event.currentTarget);
  }

  onKeyDown(event) {
    const tab = event.target;

    let newFocus;

    switch (event.key) {
      case "ArrowLeft":
        newFocus = tab.previousElementSibling || this.tabList.lastElementChild;
        break;
      case "ArrowRight":
        newFocus = tab.nextElementSibling || this.tabList.firstElementChild;
        break;
      case "Home":
        newFocus = this.tabList.firstElementChild;
        break;
      case "End":
        newFocus = this.tabList.lastElementChild;
        break;
      default:
        break;
    }

    if (newFocus) {
      event.preventDefault();
      this.handleSelect(newFocus);
    }
  }
}

customElements.define("automatic-tabs", AutomaticTabs);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    // Close HeaderDrawer and open SearchDrawer when Fake Searchbar is pressed.
    if (document.querySelector('#menu-drawer .search-modal__dialog')) {
      document.querySelector('#menu-drawer .search-modal__dialog').addEventListener("click", () => {
        document.querySelector('header-drawer > details > summary').click();
        setTimeout(() => {
          document.querySelector('#SearchModal > summary').click();
        }, 200);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;

    if (this.header) {
      this.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
      this.header.classList.add('menu-open');
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    // The MN header drawer has no data-breakpoint, so this used to add
    // `overflow-hidden-undefined`, which no CSS reads. A body class change
    // restyles the whole page when certain app CSS is loaded (Alia, on
    // collections), so skip the write rather than pay for a no-op class.
    if (this.dataset.breakpoint) document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  // Immediate by default: the MN drawer has no close transition (it is shown
  // by details[open] alone), so every close path (X, hamburger, Escape)
  // closes in the tap. The 400ms closeAnimation only froze it on screen, and
  // shut the drawer again if it was reopened inside that window.
  closeMenuDrawer(event, elementToFocus, immediate = true) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus, immediate);
    this.header = this.header || document.querySelector('.section-header');
    if (this.header) {
      this.header.classList.remove('menu-open');
    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize = throttle(() => {
    this.header &&
      this.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    this.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }, 100);
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        // A backdrop tap is always a dismissal — the old .toCart branch clicked
        // #checkout_button here, sending shoppers to checkout when they tapped
        // outside the bump modal to close it.
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section')?.id.replace('shopify-section-', '');
    document.body.appendChild(this);

    if (this.dataset.open === "true") {
      requestAnimationFrame(() => {
        this.show(null);
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if(document.querySelector('iframe#chat-button'))
      document.querySelector('iframe#chat-button').style.display = 'none'
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    this._pausedVideos = Array.from(document.querySelectorAll('video')).filter(
      (video) => !video.paused && !this.contains(video)
    );
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    // this.pauseAllMedia();
    (this._pausedVideos || []).forEach((video) => video.play().catch(() => {}));
    this._pausedVideos = [];
    document.dispatchEvent(
      new CustomEvent("ModalClose", {
        detail: {
          id: this.id,
        },
      })
    );
  }
}

customElements.define("modal-dialog", ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if(button.getAttribute("data-disabled") == "true"){
        return;
      } else {
       if (modal) modal.show(button);
      }
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.validate = this.dataset.validate === "true";
    this.updateOptions();
    if (this.validate) {
      this.validateOptionValues();
    }
  }

  connectedCallback() {
    this.addEventListener('change', throttle((event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    }, 50), { passive: true });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  onVariantChange(event) {
    this.updateOptions();
    if (this.validate) {
      this.validateOptionValues();
    }
    this.updateMasterId();
    this.updateSelectLabel();

    if (!this.currentVariant && this.validate) {
      // A half-made selection (Length picked, Size not yet) matches no variant
      // but is not sold out. Keep Add to Cart, whose submit asks for the
      // missing option; Notify is only for a full selection with no variant.
      const incomplete = this.options.includes("");
      this.toggleAddButton(!incomplete, "", true);
      if (!incomplete) this.setUnavailable();
    } else {
      // Availability and the button price come from the local variant data
      // synchronously — the section fetch in renderProductInfo used to be the
      // only trigger, leaving a sold-out size with a live ATC button for a full
      // round-trip (or forever, when the fetch failed).
      if (this.validate) {
        this.toggleAddButton(!this.currentVariant.available);
      }
      this.updateCostSpans();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      if(this.classList.contains('sticky_variant_radios')){
        this.addToCart(event);
      }
    }
  }

  // The "ADD TO CART - $X" price span never tracked variant changes; only the
  // #price-{section} block did. Mixed-price products showed a stale button price.
  updateCostSpans() {
    if (!this.currentVariant || typeof this.currentVariant.price !== 'number') return;
    const formatted = Shopify.formatMoney(this.currentVariant.price, window.money_format);
    document
      .querySelectorAll(`#product-form-${this.dataset.section} .cost`)
      .forEach((el) => {
        el.dataset.defaultCurrency = formatted;
        el.textContent = formatted;
      });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  // Until every option is picked, the main button reads "Select size" (the
  // first unpicked option) instead of "Add to cart - $X". The Liquid in
  // main-product-add-to-cart.liquid renders the same state on load. The
  // sticky picker auto-submits and has its own button, so it is left out.
  updateSelectLabel() {
    if (this.classList.contains('sticky_variant_radios')) return;
    const addButton = document.querySelector(`#product-form-${this.dataset.section} [name="add"]`);
    const label = addButton?.querySelector('.product-form__select-label');
    if (!label) return;

    const index = this.options.indexOf("");
    const field = index === -1 ? null : this.querySelectorAll("fieldset, select")[index];
    const input = field?.tagName === "SELECT" ? field : field?.querySelector("input");
    const name = input ? input.name.replace(/^options\[(.*)\]$/, "$1").toLowerCase() : "";

    addButton.toggleAttribute("data-needs-option", Boolean(name));
    if (name) {
      label.textContent = (addButton.dataset.selectLabel || "Select {option}").replace("{option}", name);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    // Used to update the variant ID for the sticky add-to-cart component.
    const stickyVariantId = document.querySelector('.sticky-add-to-cart product-form input[name="id"]')
    if(stickyVariantId && this.currentVariant)
      stickyVariantId.value = this.currentVariant.id

    document.dispatchEvent(
      new CustomEvent("variantChange", {
        detail: {
          variant: this.currentVariant,
        },
      })
    );
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild === newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader =
      this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    window.setTimeout(() => {
      parent
        .querySelector("li.product__media-item")
        .scrollIntoView({ behavior: "smooth" });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', this.currentVariant.id);
    window.history.replaceState({}, "", url.toString());
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        const quantity_warning_selector = '.low-stock-warning';
        const quantity_warning_source = html.querySelector(quantity_warning_selector);
        const quantity_warning_destination = document.querySelector(quantity_warning_selector);
        if (quantity_warning_source && quantity_warning_destination) quantity_warning_destination.innerHTML = quantity_warning_source.innerHTML;

        if (source && destination) destination.innerHTML = source.innerHTML;

        if (destination) {
          destination.querySelectorAll(".money").forEach((element) => {
            element.dataset.defaultCurrency = element.innerHTML;
            element.dataset.currency = window.default_currency;
          });
          if (window.convertCurrency) window.convertCurrency(destination);
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("invisible");
        if (this.validate) {
          this.toggleAddButton(
            !this.currentVariant?.available
          );
        }
      })
      .catch(() => {
        // Availability and price were already applied synchronously in
        // onVariantChange — a failed section fetch only skips the markup refresh.
      });
  }

  addToCart(event) {
    const selectedVariant = event?.target?.closest('label');
    if (selectedVariant) {
      selectedVariant.classList.add('loading');
      // The label is cleared when the sticky selector closes on success; this is
      // the failure fallback so it can't stay stuck spinning.
      setTimeout(() => selectedVariant.classList.remove('loading'), 4000);
    }
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    // Mirror before submitting: ProductForm.areRequiredVariantOptionsSelected
    // reads the main picker, so submitting first lost the first tap to a
    // "Pick a Size" prompt hidden behind the sheet.
    this.mirrorToMainPicker();
    productForm.dispatchEvent(new CustomEvent('submit', {detail: {submittedBy: selectedVariant,},}));
  }

  // Copies every sticky choice onto the main picker, not just the one just
  // tapped: a Length picked earlier in the sheet has to reach it too. Radios
  // are matched by name and value; sticky ids never match the main picker's.
  // Setting .checked fires no change event, so the main picker's options and
  // "Select size" label are refreshed here.
  mirrorToMainPicker() {
    const mainPicker = document.querySelector('.product__info-container variant-radios:not(.sticky_variant_radios)');
    if (!mainPicker) return;
    this.querySelectorAll('fieldset input:checked').forEach((input) => {
      const mainRadio = mainPicker.querySelector(
        `input[name="${CSS.escape(input.name)}"][value="${CSS.escape(input.value)}"]`
      );
      if (mainRadio) mainRadio.checked = true;
    });
    mainPicker.updateOptions();
    if (mainPicker.validate) mainPicker.validateOptionValues();
    mainPicker.updateSelectLabel();
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    // Login-required and app-exclusive products render neither button.
    const addButton = productForm.querySelector('[name="add"]');
    const notifyButton = productForm.querySelector('[name="notify"]');

    if (disable) {
      addButton?.classList.add("hidden");
      notifyButton?.classList.remove("hidden");
    } else {
      notifyButton?.classList.add("hidden");
      addButton?.classList.remove("hidden");
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    // const addButton = productForm.querySelector('[name="add"]');
    // if (!addButton) return;
    // addButton.textContent = window.variantStrings.notify;
  }

  validateOptionValues() {
    Array.from(this.querySelectorAll("select")).forEach((select, i) => {
      select.querySelectorAll("option").forEach((option) => {
        const options = Object.assign([], this.options, {
          [i]: option.value,
        });
        const available = this.getVariantData().find((variant) =>
          options.every((option) => variant.options.includes(option))
        )?.available;
        available
          ? option.removeAttribute("disabled")
          : option.setAttribute("disabled", "disabled");
      });
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      const checked = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );

      return checked ? checked.value : "";
    });

    //Update Plus/Minus buttons and input value based on availability.
    fieldsets.forEach((fieldset) => {
      const checked = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      if (!checked) return;

      // The `available` attribute is only meaningful for tracked, deny-policy
      // variants (the Liquid omits it otherwise). Untracked / continue-selling
      // variants report 0 on hand while being freely purchasable — the old
      // truthy-string check ("0") clamped those to qty 1 with a disabled plus.
      const available = checked.getAttribute('available');
      const max = available === null || available === '' ? null : Number(available);
      const selectors = ['.product-form__quantity quantity-input','.sticky-add-to-cart quantity-input'];
      selectors.forEach((selector) => {
        const quantityContainer = document.querySelector(selector);
        if (!quantityContainer) return;
        const qtyInput = quantityContainer.querySelector('input');
        if (!qtyInput) return;
        const plusBtn = quantityContainer.querySelector('[name="plus"]');

        if (max === null || !Number.isFinite(max) || max <= 0) {
          // No cap (or a sold-out variant, where the ATC/notify swap governs).
          qtyInput.removeAttribute('max');
          plusBtn?.classList.remove('disabled');
        } else {
          qtyInput.setAttribute('max', max);
          if (Number(qtyInput.value) >= max) {
            qtyInput.value = Math.min(Number(qtyInput.value) || 1, max);
            plusBtn?.classList.add('disabled');
          } else {
            plusBtn?.classList.remove('disabled');
          }
        }

        quantityContainer.querySelector('[name="minus"]')?.classList.toggle('disabled', Number(qtyInput.value) == 0);
      })
    })
  }

  validateOptionValues() {
    Array.from(this.querySelectorAll("fieldset")).forEach((fieldset, i) => {
      fieldset.querySelectorAll("input").forEach((radio) => {
        const available = this.getVariantData().some((variant) => {
          if (!variant.available) return false;
          if (variant.options[i] !== radio.value) return false;
          for (let j = 0; j < i; j++) {
            if (this.options[j] && variant.options[j] !== this.options[j]) return false;
          }
          return true;
        });
        available
          ? radio.classList.remove('disabled')
          : radio.classList.add('disabled');
          // ? radio.removeAttribute("disabled")
          // : radio.setAttribute("disabled", "disabled");
      });
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          // Trigger lazy loading for dynamically added content
          if (window.lazyloadPolyfill) {
            window.lazyloadPolyfill(this);
          }
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(throttle((entries) => this.initPages(), 100));
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", throttle(this.update.bind(this), 16), { passive: true }); // ~60fps

    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', throttle(this.setSlideVisibility.bind(this), 16), { passive: true }); // ~60fps
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class BackButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", () => {
      window.location = document.referrer.includes(window.location.hostname)
        ? document.referrer
        : "/";
    });
  }
}

customElements.define("back-button", BackButton);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
    this.queueProcessorRunning = false;
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    // Use requestAnimationFrame instead of setInterval for better performance
    if (!this.queueProcessorRunning) {
      this.queueProcessorRunning = true;
      this.processQueue();
    }
  }

  processQueue() {
    if (this.queue.length > 0) {
      if (!this.requestStarted) {
        this.sendRequest(this.queue);
      }
      // Continue processing
      setTimeout(() => this.processQueue(), BulkAdd.ASYNC_REQUEST_DELAY);
    } else {
      this.queueProcessorRunning = false;
    }
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}


class SmoothAnchor extends HTMLElement {
  constructor() {
    super();
    this.anchor = this.querySelector("a");
  }

  connectedCallback() {
    this.anchor.addEventListener("click", this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    document
      .querySelector(this.anchor.getAttribute("href"))
      .scrollIntoView({ behavior: "smooth" });
  }
}

customElements.define("smooth-anchor", SmoothAnchor);

class ShareButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector("button").addEventListener(
      "click",
      this.onClick.bind(this)
    );
  }

  async onClick(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const link = button.value;
    const title = decodeURIComponent(button.name);

    try {
      await navigator.share({
        url: link,
        title: title,
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "Share",
        eventModel: {
          label: link,
        },
      });
    } catch (error) {
      console.error(error);
    }
  }
}

customElements.define("share-button", ShareButton);

class ClipboardButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector("button").addEventListener(
      "click",
      this.onClick.bind(this)
    );
  }

  async onClick(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const link = button.value;

    try {
      clearTimeout(this.timeout);
      await navigator.clipboard.writeText(link);
      button.classList.add("done");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "Copy",
        eventModel: {
          label: link,
        },
      });
    } catch (error) {
      console.error(error);
    }
    this.timeout = setTimeout(() => {
      button.classList.remove("done");
    }, 2000);
  }
}

customElements.define("clipboard-button", ClipboardButton);

function bumpOpen() {
  document.querySelector("[id^='BumpDrawer-']")?.setAttribute("open","");
}

// Discount code collapse A/B (cart drawer + cart page summary): tapping the
// "Have a code?" link expands the form back into view. Harmless in the
// control arm since the toggle stays hidden there.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-discount-toggle]');
  if (!toggle) return;
  toggle.closest('[data-discount-group]')?.classList.add('is-expanded');
});

function checkHeaderHeight() {
  // const header = document.querySelector('#shopify-section-header');
  // const topBar = document.querySelector('#shopify-section-header .topbar');
  // const trueHeaderHeight = header.clientHeight - topBar.clientHeight
  const stickyHeader = document.querySelector('sticky-header');
  if (!stickyHeader) return;
  document.body?.style.setProperty("--headerHeight", `${stickyHeader.clientHeight}px`);
}

document.addEventListener("DOMContentLoaded", () => {
  checkHeaderHeight();
  // Re-measure when announcement bar is dismissed (removed or height changes)
  const annBar = document.getElementById('Announcement-header');
  if (annBar) {
    new MutationObserver(checkHeaderHeight).observe(annBar, { attributes: true, childList: false });
    if (annBar.parentNode) {
      new MutationObserver(checkHeaderHeight).observe(annBar.parentNode, { childList: true });
    }
  }
  // The header only changes height when its own box changes (sticky state,
  // announcement bar, viewport). Watching it directly is far cheaper than
  // re-reading clientHeight and writing a style on every scroll tick, which
  // forced a layout during scroll on every page.
  const stickyHeader = document.querySelector('sticky-header');
  if (stickyHeader && window.ResizeObserver) {
    new ResizeObserver(throttle(checkHeaderHeight, 100)).observe(stickyHeader);
  } else {
    window.addEventListener('scroll', throttle(checkHeaderHeight, 100), { passive: true });
  }
});

window.addEventListener('resize', throttle(checkHeaderHeight, 250), { passive: true });

/*
 * Check if element is in viewport.
 * RETURNS: Boolean
 */
function elementInViewport(element) {
  if(element){
    const elementClientRect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    return (
      (elementClientRect.top >= 0 && elementClientRect.top <= viewportHeight) ||
      (elementClientRect.bottom >= 0 && elementClientRect.bottom <= viewportHeight)
    );
  }
  return false
}

// Use IntersectionObserver for better performance instead of scroll events
let sectionObserver;
// Sections already handed to the observer, so a re-check only picks up ones
// added since (infinite scroll, section rendering swaps) instead of tearing
// the observer down and rebuilding it over every section on each scroll tick.
const observedSections = new WeakSet();

// Throttled scroll handler to prevent excessive CPU usage
const throttledCheckSectionsInView = throttle(checkSectionsInView, 100);
checkSectionsInView();
window.addEventListener('scroll', throttledCheckSectionsInView, { passive: true });

function initSectionObserver() {
  if (!sectionObserver) {
    sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('visible')) {
          entry.target.classList.add('visible');
          // Stop observing once visible to improve performance
          sectionObserver.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '50px',
      threshold: 0.1
    });
  }

  // Observe sections we have not seen yet
  document.querySelectorAll('section').forEach(section => {
    if (observedSections.has(section)) return;
    observedSections.add(section);
    if (!section.classList.contains('visible')) {
      sectionObserver.observe(section);
    }
  });
}

function checkSectionsInView(){
  // Fallback for browsers without IntersectionObserver support
  if (!window.IntersectionObserver) {
    document.querySelectorAll('section').forEach(section => {
      if(!section.classList.contains('visible') && elementInViewport(section) ){
        section.classList.add('visible')
      }
    })
  } else {
    initSectionObserver();
  }
}

// Performance fix: Replace aggressive setInterval with MutationObserver and event delegation
if(document.querySelector('body.template-product')){
  let stickyCartElement = null;
  let productFormContainer = null;
  let intervalId = null;

  // Cache DOM elements
  function initProductFormObserver() {
    stickyCartElement = document.querySelector('.sticky-add-to-cart');
    productFormContainer = document.querySelector('.product-form__radio-wrapper');

    if (!stickyCartElement || !productFormContainer) {
      // Fallback with longer interval if elements not found
      intervalId = setInterval(checkDisabledState, 1000);
      return;
    }

    // Use MutationObserver for better performance
    const observer = new MutationObserver(throttle(checkDisabledState, 100));
    observer.observe(productFormContainer, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      subtree: true
    });

    // Also listen to change events on radio inputs
    productFormContainer.addEventListener('change', throttle(checkDisabledState, 50), { passive: true });

    // Initial check
    checkDisabledState();

    // Cleanup function
    window.addEventListener('beforeunload', () => {
      observer.disconnect();
      if (intervalId) clearInterval(intervalId);
    });
  }

  function checkDisabledState() {
    if (!stickyCartElement) {
      stickyCartElement = document.querySelector('.sticky-add-to-cart');
      if (!stickyCartElement) return;
    }

    const hasDisabledChecked = document.querySelectorAll('.product-form__radio-wrapper input[type="radio"].disabled:checked').length > 0;

    if (hasDisabledChecked) {
      stickyCartElement.classList.add('disable');
    } else {
      stickyCartElement.classList.remove('disable');
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFormObserver);
  } else {
    initProductFormObserver();
  }
}


class SliderCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = true;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    this.resizeObserver = new ResizeObserver(throttle(() => this.initPages(), 100));
    this.resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", throttle(this.update.bind(this), 16), { passive: true }); // ~60fps

    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = String(this.currentPage).padStart(
        2,
        "0"
      );
      this.pageTotalElement.textContent = String(this.totalPages).padStart(
        2,
        "0"
      );
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    // if (
    //   this.isSlideVisible(this.sliderItemsToShow[0]) &&
    //   this.slider.scrollLeft === 0
    // ) {
    //   this.prevButton.setAttribute("disabled", "disabled");
    // } else {
    //   this.prevButton.removeAttribute("disabled");
    // }

    // if (
    //   this.isSlideVisible(
    //     this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
    //   )
    // ) {
    //   this.nextButton.setAttribute("disabled", "disabled");
    // } else {
    //   this.nextButton.removeAttribute("disabled");
    // }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  disconnectedCallback() {
    // Clean up observers to prevent memory leaks
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

// customElements.define("slider-carousel-component", SliderCarouselComponent);

function createToast(text){

  let toast = document.querySelector('.toast')
  let toastMessage = document.querySelector('.toast-message')

  toastMessage.textContent = text;

  toast.classList.add('visible')

  setTimeout(function(){
    toastMessage.classList.add('reveal')
    setTimeout(function(){
      toastMessage.classList.remove('reveal')
      setTimeout(function(){
        toast.classList.remove('visible')
      },250)
    },1500)
  },250)

}

//Sticky variant selector

function handleStickyATCClick(){
  if(!document.querySelector('.sticky_variants_wrapper')){
    document.querySelector('#product-header').scrollIntoView();
    document.querySelector('#product-header [action=\'/cart/add\'] [type=\'submit\']').click();
  } else {
    document.querySelector('.sticky_variants_wrapper').addEventListener('click', function(event){
      if(event.target == document.querySelector('.sticky_variants_wrapper')){
        closeStickyVariantSelector();
      }
    })
    document.querySelector('.sticky_variants_wrapper').classList.add('open');
    document.querySelector('#gorgias-chat-container')?.classList.add('hidden');
    document.body.classList.add('overflow-hidden');
  }
}

function closeStickyVariantSelector(){
  document.querySelector('.sticky_variants_wrapper').classList.remove('open');
  if(document.querySelector('.sticky_variants label.loading') != null){
      document.querySelector('.sticky_variants label.loading').classList.remove('loading');
  }
  document.body.classList.remove('overflow-hidden')
  document.querySelector('#gorgias-chat-container')?.classList.remove('hidden');
}

/**
 * Utility function to handle lazy loading and other polyfills for dynamically added content
 * Call this function whenever you add product cards or other content with images to the DOM
 * @param {HTMLElement} container - The container element that has new content
 */
window.initializeDynamicContent = function(container) {
  if (!container) return;

  // Trigger lazy loading
  if (window.lazyloadPolyfill) {
    window.lazyloadPolyfill(container);
  }

  // Trigger currency conversion if available
  if (window.convertCurrency) {
    window.convertCurrency(container);
  }

  // Trigger scroll animations if available
  if (typeof initializeScrollAnimationTrigger === 'function') {
    initializeScrollAnimationTrigger(container);
  }

  // Additional polyfills and initializations can be added here
};

// Backward compatibility - ensure lazyloadPolyfill is available
if (!window.lazyloadPolyfill) {
  window.lazyloadPolyfill = function(container) {
    console.warn('lazyloadPolyfill not available - make sure theme.liquid is loaded properly');
  };
}

// Performance monitoring and cleanup utilities
window.performanceUtils = {
  // Cleanup function to prevent memory leaks
  cleanup: function() {
    // Clear any remaining intervals
    for (let i = 1; i < 99999; i++) {
      window.clearInterval(i);
    }

    // Disconnect all observers if they exist
    if (window.sectionObserver) {
      window.sectionObserver.disconnect();
    }
  },

  // Monitor performance issues
  monitor: function() {
    if (window.performance && window.performance.now) {
      const startTime = window.performance.now();

      // Check for long-running tasks
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.duration > 50) { // Tasks longer than 50ms
            console.warn('Long task detected:', entry.name, entry.duration + 'ms');
          }
        }
      });

      try {
        observer.observe({ entryTypes: ['longtask'] });
      } catch (e) {
        // longtask not supported in all browsers
      }
    }
  }
};

// Initialize performance monitoring
if (typeof window !== 'undefined') {
  window.performanceUtils.monitor();

  // Cleanup on page unload
  window.addEventListener('beforeunload', window.performanceUtils.cleanup);
}

// Collection description "Show More": only show the toggle when the clamped
// text actually overflows its line clamp (2 lines). Re-checks on resize and
// after fonts/images load since either can change the line count.
(function () {
  function updateCollapsibleToggles() {
    document.querySelectorAll('.collapsible-section').forEach(function (section) {
      var input = section.querySelector(':scope > input[type="checkbox"]');
      var content = section.querySelector(':scope > div');
      var label = section.querySelector(':scope > label');
      if (!content || !label) return;
      if (input && input.checked) return; // expanded — keep "Show Less" visible
      var truncated = content.scrollHeight > content.clientHeight + 1;
      section.classList.toggle('collapsible-section--truncated', truncated);
    });
  }

  var collapsibleToggleResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(collapsibleToggleResizeTimer);
    collapsibleToggleResizeTimer = setTimeout(updateCollapsibleToggles, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCollapsibleToggles);
  } else {
    updateCollapsibleToggles();
  }
  window.addEventListener('load', updateCollapsibleToggles);
  document.addEventListener('shopify:section:load', updateCollapsibleToggles);
})();
